import { formatDate } from "../shared/util/string.util";

/* eslint-disable */
const numberLetter = function(value) {
  let suffixes = [
    "U",
    "D",
    "C",
    "K",
    "K",
    "K",
    "M",
    "M",
    "M",
    "B",
    "B",
    "B",
    "T",
    "T",
    "T"
  ];

  if (!value) {
    return false;
  }
  let stringValue = value.toString();
  let valueLength = stringValue.length;
  let suffix = suffixes[valueLength - 1];

  const BASEDIVISOR = 3;
  let startindex = 0;
  let characterToTake = valueLength % BASEDIVISOR;
  characterToTake = characterToTake == 0 ? BASEDIVISOR : characterToTake;

  if (valueLength > BASEDIVISOR) {
    let wholePart = stringValue.substr(startindex, characterToTake);
    let decimalPart = stringValue.substr(
      startindex + characterToTake,
      BASEDIVISOR
    );

    let firstDecimal = decimalPart.substr(startindex, 1);

    let wholeNumber =
      firstDecimal != "0"
        ? wholePart + "." + decimalPart.substr(startindex, 1) + suffix
        : wholePart + suffix;

    return wholeNumber;
  }

  return stringValue;
};

const validateProductExpirationDate = (products, productId, finalDate) => {
  const actualProduct = products.find(
    product => product.productId == productId
  );
  const expirationDate = formatDate(new Date(actualProduct.expirationDate));

  const finalDateValidated =
    expirationDate < finalDate ? expirationDate : finalDate;

  return !actualProduct.isActived ? finalDateValidated : finalDate;
};

const sortArrayObjectDesc = ( array = [],property = "" ) => {
  return array.sort((a,b) => {
    if ( Number(a[property]) < Number(b[property]) ){
      return 1;
    }
    if ( Number(a[property]) > Number(b[property]) ){
      return -1;
    }
    return 0;
  })
}

export { numberLetter, validateProductExpirationDate, sortArrayObjectDesc };
